import $ from 'jquery';

$(function () {
  var $rewardThresholdToggle = $('#js-explicit-reward-thresholds-toggle');
  var $rewardsEnabledInput = $('#js-explicit-rewards-enabled-input');
  var $rewardThresholdsInputAreas = $('.threshold-input-area');
  var $rewardThresholdInputs = $('.reward-threshold-input');
  var $rewardsToggleButton = $('#js-rewards-toggle-button');
  var $rewardsForm = $('form#rewards-edit');
  var toggleRewardThresholds = function () {
    if (
      $rewardThresholdToggle.is(':checked') &&
      $rewardThresholdToggle.length != 0
    ) {
      $rewardThresholdsInputAreas.show();
      $rewardThresholdInputs.prop('disabled', false);
    } else {
      $rewardThresholdsInputAreas.hide();
      $rewardThresholdInputs.prop('disabled', true);
    }
  };
  var toggleRewardsEnabled = function () {
    if ($rewardsEnabledInput.val() === 'true') {
      $rewardsForm.removeClass('rewards-disabled');
    } else {
      $rewardsForm.addClass('rewards-disabled');
    }
  };
  toggleRewardThresholds();
  toggleRewardsEnabled();
  var wasChecked = $rewardThresholdToggle.is(':checked');

  $('#js-reward-threshold-submit').click(function () {
    if (
      $rewardThresholdToggle.is(':checked') != wasChecked &&
      $('#reward_config_is_onboarding').val() == 'false'
    ) {
      $('#js-threshold-warning').modal('show');
      return;
    } else {
      $('#rewards-edit').submit();
    }
  });

  $('.js-positive-feedback-components-submit').click(function (e) {
    if (
      $rewardThresholdToggle.is(':checked') != wasChecked &&
      $('#reward_config_is_onboarding').val() == 'false'
    ) {
      e.preventDefault();
      $('#js-threshold-warning').modal('show');
      return;
    } else {
      $('.js-positive-feedback-components-form').submit();
    }
  });
  $rewardsToggleButton.click(function () {
    $rewardsEnabledInput.val(
      $rewardsToggleButton.attr('enabled') === 'true' ? 'false' : 'true',
    );
    $('#js-rewards-toggle-warning').modal('show');
  });
  $('#js-rewards-toggle-warning').on('hidden.bs.modal', function () {
    $rewardsEnabledInput.val($rewardsToggleButton.attr('enabled'));
  });

  $rewardThresholdToggle.bootstrapSwitch({
    onText: 'Yes',
    offText: 'No',
    onSwitchChange: toggleRewardThresholds,
    onInit: toggleRewardThresholds,
  });
});
